<template>
  <div>
    <h3>优惠券活动</h3>
    <el-form
      :disabled="disabled"
      size="mini"
      label-width="180px"
      class="demo-form-inline"
      :model="activityInfo"
      :rules="rules"
      ref="activityInfo"
    >
      <el-form-item label="优惠券活动类型" prop="activityType">
        <el-radio-group v-model="activityInfo.activityType">
          <el-radio
            v-for="(label, value) in map.coupon.activityType"
            :key="value"
            :label="Number(value)"
            >{{ label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="优惠券类型">
        <el-select v-model="activityInfo.type">
          <el-option
            v-for="(label, value) in map.coupon.type"
            :key="value"
            :label="label"
            :value="Number(value)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="优惠券名称" prop="activityName">
        <el-alert
          title="选择灵活发放，名称中必须包含“甲方微服务成单”,“邀请人注册”,“邀请人结算”之一"
          type="info"
          :closable="false"
        >
          <el-input
            type="text"
            v-model.trim="activityInfo.activityName"
            placeholder="优惠券活动名称"
          />
          <p></p>
        </el-alert>
      </el-form-item>
      <el-form-item label="优惠券金额">
        <el-input
          type="number"
          v-model.number="activityInfo.couponAmount"
          placeholder="优惠券金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="优惠券门槛金额">
        <el-input
          type="number"
          v-model.number="activityInfo.thresholdAmount"
          placeholder="优惠券门槛金额，需大于等于优惠券金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="优惠券最小金额" prop="amountMin">
        <el-input
          type="number"
          v-model.number="activityInfo.amountMin"
          placeholder="优惠券最小金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="优惠券最大金额" prop="amountMax">
        <el-input
          type="number"
          v-model.number="activityInfo.amountMax"
          placeholder="优惠券最大金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="优惠券有效时间" prop="validTime">
        <el-input
          type="number"
          v-model.number="activityInfo.validTime"
          placeholder="优惠券有效时间"
        >
          <template slot="append">天</template>
        </el-input>
      </el-form-item>
      <el-form-item label="优惠券活动时间">
        <el-col :span="11">
          <el-form-item prop="activityStartTime">
            <el-date-picker
              v-model="activityInfo.activityStartTime"
              type="date"
              placeholder="开始时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :editable="false"
              :picker-options="startTime"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col class="line" :span="2">至</el-col>
        <el-col :span="11">
          <el-form-item prop="activityEndTime">
            <el-date-picker
              v-model="activityInfo.activityEndTime"
              type="date"
              placeholder="结束时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :editable="false"
              :picker-options="endTime"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="优惠券数量" prop="couponNum">
        <el-input
          type="number"
          v-model.number="activityInfo.couponNum"
          min="1"
          step="1"
          placeholder="优惠券数量"
        ></el-input>
      </el-form-item>
      <el-form-item label="发放总金额" prop="totalAmount">
        <el-input
          type="number"
          v-model.number="activityInfo.totalAmount"
          placeholder="发放总金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="优惠券可领取数量限制" prop="limitNum">
        <el-input
          type="number"
          v-model.number="activityInfo.limitNum"
          min="1"
          step="1"
          placeholder="优惠券可领取数量限制"
        ></el-input>
      </el-form-item>
      <el-form-item label="优惠券使用条件" prop="useCondition">
        <el-radio-group v-model="activityInfo.useCondition">
          <el-radio
            v-for="(label, value) in map.coupon.useCondition"
            :key="value"
            :label="Number(value)"
            >{{ label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="false" label="优惠券是否可叠加">
        <el-radio-group>
          <el-radio>是</el-radio>
          <el-radio>否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="优惠券领取用户限制">
        <el-radio-group v-model="activityInfo.forPeople">
          <el-radio
            v-for="(label, value) in map.coupon.forPeople"
            :key="value"
            :label="Number(value)"
            >{{ label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="activityInfo.forPeople === 5"
        label=""
        prop="assignUser"
      >
        <el-alert
          title="选择指定用户可领优惠券，需填写可领取优惠券的用户ID，多个ID试用‘#’隔开"
          type="info"
          :closable="false"
        >
          <el-input
            type="textarea"
            v-model="assignUser"
            placeholder="填写可领取优惠券用户id"
          ></el-input>
        </el-alert>
      </el-form-item>
      <el-form-item label="是否需要兑换码验证领取" prop="needToExchange">
        <el-radio-group v-model="activityInfo.needToExchange">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="id" label="是否上线">
        <el-radio-group v-model="activityInfo.isOnline">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="!disabled" label="">
        <el-button type="primary" @click="submit">{{
          id ? "保存" : "创建"
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";

const { coupon } = api;

export default {
  name: "couponActivity",
  data() {
    var checkNumber = (rule, value, callback) => {
      var reg = /^(([1-9](\d*)?)|0)(\.\d{1,2})?$/;
      if (value < 0 || !reg.test(value)) {
        callback(new Error("请输入正确的数值"));
      } else {
        callback();
      }
    };
    return {
      disabled: false,
      map,
      activityInfo: {
        activityType: "",
        activityName: "",
        type: 1,
        thresholdAmount: "",
        couponAmount: "",
        amountMin: "",
        amountMax: "",
        validTime: "",
        activityStartTime: "",
        activityEndTime: "",
        couponNum: 1,
        totalAmount: "",
        useCondition: "",
        forPeople: "",
        assignUser: [],
        needToExchange: "",
        limitNum: 1,
      },
      assignUser: "",
      rules: {
        activityType: [
          {
            required: true,
            message: "请选择优惠券活动类型",
            trigger: "change",
          },
        ],
        thresholdAmount: [
          {
            required: true,
            message: "请输入优惠券门槛金额",
            trigger: "blur",
          },
          {
            validator: checkNumber,
            message: "请输入正确的优惠券门槛金额，最多可保留两位小数",
            trigger: "blur",
          },
        ],
        activityName: [
          {
            required: true,
            message: "请输入优惠券活动名称",
            trigger: "blur",
          },
        ],
        couponAmount: [
          {
            required: true,
            message: "请输入优惠券金额",
            trigger: "blur",
          },
          {
            validator: checkNumber,
            message: "请输入正确的优惠券金额，最多可保留两位小数",
            trigger: "blur",
          },
        ],
        validTime: [
          {
            required: true,
            message: "请输入优惠券有效时间",
            trigger: "blur",
          },
          {
            type: "integer",
            message: "请输入正整数值",
            trigger: "blur",
          },
        ],
        activityStartTime: [
          {
            required: true,
            message: "请输入优惠券活动时间",
            trigger: "blur",
          },
        ],
        activityEndTime: [
          {
            required: true,
            message: "请输入优惠券活动时间",
            trigger: "blur",
          },
        ],
        couponNum: [
          {
            required: true,
            message: "请输入优惠券数量",
            trigger: "blur",
          },
          {
            type: "integer",
            message: "请输入正整数值",
            trigger: "blur",
          },
        ],
        useCondition: [
          {
            required: true,
            message: "请选择优惠券使用条件",
            trigger: "change",
          },
        ],
        forPeople: [
          {
            required: true,
            message: "请选择优惠券领取用户",
            trigger: "change",
          },
        ],
        assignUser: [
          {
            required: true,
            message: "请输入可领取优惠券的用户ID",
            trigger: "blur",
          },
        ],
        amountMin: [
          {
            required: true,
            message: "请输入优惠券最小金额",
            trigger: "blur",
          },
        ],
        amountMax: [
          {
            required: true,
            message: "请输入优惠券最大金额",
            trigger: "blur",
          },
        ],
        totalAmount: [
          {
            required: true,
            message: "发放总金额",
            trigger: "blur",
          },
        ],
        limitNum: [
          {
            required: true,
            message: "请输入优惠券可领取数量限制",
            trigger: "blur",
          },
        ],
      },
      isSubmiting: false,
    };
  },
  computed: {
    id() {
      return this.$route.query.id || "";
    },
    action() {
      return this.id ? "update" : "create";
    },
    startTime() {
      let vue = this;
      return {
        disabledDate(time) {
          return false;
          return (
            time.getTime() < Date.now() ||
            time.getTime() >=
              new Date(vue.activityInfo.activityEndTime).getTime()
          );
        },
      };
    },
    endTime() {
      let vue = this;
      return {
        disabledDate(time) {
          return false;
          return (
            time.getTime() <=
            new Date(vue.activityInfo.activityStartTime).getTime()
          );
        },
      };
    },
  },
  watch: {
    assignUser(value) {
      if (value) {
        this.activityInfo.assignUser = value.split("#");
      } else {
        this.activityInfo.assignUser = [];
      }
    },
  },
  created() {
    if (this.$route.query.couponActivityId) {
      this.disabled = true;
    }
    if (this.id ? this.id : this.$route.query.couponActivityId) {
      this.getDetail();
    }
  },
  mounted() {},
  methods: {
    async getDetail() {
      let obj = {
        id: this.id ? this.id : this.$route.query.couponActivityId,
      };
      let {
        data: { code, data },
      } = await api.coupon.detail(obj);
      if (code == 200) {
        this.activityInfo = data;
        if (data.assignUser) {
          this.assignUser = data.assignUser.join("#");
        }
      }
    },
    submit() {
      this.$refs.activityInfo.validate((valid) => {
        if (valid) {
          let text = this.id ? "是否确认修改活动信息?" : "确认创建优惠券活动?";
          this.$confirm(text, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "再想想",
            type: "warning",
          })
            .then(async () => {
              if (this.isSubmiting) return false;
              this.isSubmiting = true;
              let obj = this.activityInfo;
              let {
                data: { code, data },
              } = await api.coupon[this.action](obj);
              let vue = this;
              if (code == 200) {
                this.$message({
                  showClose: false,
                  message: "保存成功",
                  type: "success",
                  onClose() {
                    if (vue.id) {
                      window.location.reload();
                    } else {
                      window.location.href = `/coupon/activities`;
                    }
                  },
                });
              }
              this.isSubmiting = false;
            })
            .catch((e) => {
              this.isSubmiting = false;
              if (e === "cancel") {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "保存失败",
                });
              }
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.demo-form-inline {
  width: 680px;
}

.line {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/coupon/activity.vue